<script setup lang="ts">
import LoyaltyCreateContainer from './LoyaltyCreateContainer.vue'
import EmbedVideo from '@/components/EmbedVideo.vue'

const storageUrl = computed(() => `${import.meta.env.VITE_AWS_STORAGE_URL}/loyalty`)
const { t } = useI18n()
const { availableOnboardingIntegrations } = useIntegration()
</script>

<template>
  <LoyaltyCreateContainer>
    <div
      class="align-stretch flex w-full flex-col items-center justify-center gap-10 self-center overflow-auto p-10 xl:flex-row"
    >
      <div
        class="flex h-full w-full flex-col items-start justify-center gap-2 overflow-auto rounded-lg bg-muted p-5 text-sm xl:w-1/2 xl:gap-3"
      >
        <div class="flex items-center justify-center gap-4">
          <img class="hidden aspect-square h-14 object-contain sm:block" :src="`${storageUrl}/step1_buy.png`" />
          <p>{{ t('pages.loyalty.create.instructions.afterPayment') }}</p>
        </div>
        <div class="flex items-center justify-center gap-4">
          <img class="hidden aspect-square h-14 object-contain sm:block" :src="`${storageUrl}/step2_earn_points.png`" />
          <p>
            {{ t('pages.loyalty.create.instructions.withScan') }}
          </p>
        </div>
        <div class="flex items-center justify-center gap-4">
          <img class="hidden aspect-square h-14 object-contain sm:block" :src="`${storageUrl}/step3_rewards.png`" />
          <p>{{ t('pages.loyalty.create.instructions.withPoints') }}</p>
        </div>
        <div class="flex items-center justify-center gap-4">
          <img class="hidden aspect-square h-14 object-contain sm:block" :src="`${storageUrl}/step4_scan.png`" />
          <p>{{ t('pages.loyalty.create.instructions.retrieve') }}</p>
        </div>
      </div>
      <div class="flex h-full w-full flex-col justify-between xl:w-1/2">
        <EmbedVideo
          class="mb-5 w-1/2 self-center border xl:w-full"
          link="https://www.youtube.com/embed/hSBBZlyA070?autoplay=1&loop=1&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3&playlist=hSBBZlyA070"
        />
        <div class="grid grid-cols-2 gap-x-14 gap-y-2 sm:grid-cols-3">
          <div
            v-for="(integration, index) in availableOnboardingIntegrations"
            :key="index"
            class="flex h-10 justify-start rounded-md py-2 sm:justify-between"
          >
            <img class="h-full object-contain" :src="integration.logo" />
          </div>
        </div>
      </div>
    </div>
  </LoyaltyCreateContainer>
</template>
